import { TouchableBox, Box, AHText } from "arkh";
import React from "react";

export function TabButton(props: {
  title: string | React.ReactNode;
  onPress: () => void;
  isActive?: boolean;
  badge: React.ReactElement | null;
}) {
  return (
    <TouchableBox space="xsmall" onPress={props.onPress}>
      <Box
        spaceHorizontal="small"
        color={props.isActive ? "text-primary" : "transparent"}
        borderColor={props.isActive ? "text-primary" : "border-primary"}
        cornerRadius="large"
        style={{
          borderWidth: 1,
          flexDirection: "row",
          alignItems: "center",
          height: 34,
        }}
      >
        <AHText
          type="subtitle"
          color={props.isActive ? "text-inverted" : "text-primary"}
        >
          {props.title}
        </AHText>
        {props.badge}
      </Box>
    </TouchableBox>
  );
}
